var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestricted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filterRestricted_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2347 43.7144C18.4022 43.8947 18.5736 44.0726 18.749 44.248C18.9245 44.4234 19.1024 44.5949 19.2826 44.7623C27.032 51.9607 39.1523 51.7892 46.6935 44.248C54.2347 36.7068 54.4061 24.5866 47.2078 16.8372C47.0403 16.6569 46.8689 16.479 46.6935 16.3036C46.518 16.1282 46.3401 15.9567 46.1599 15.7893C38.4105 8.59092 26.2903 8.76236 18.749 16.3036C11.2078 23.8448 11.0364 35.965 18.2347 43.7144ZM20.3313 43.7136C27.5012 50.3337 38.6832 50.1625 45.6456 43.2001C52.608 36.2377 52.7791 25.0558 46.1591 17.8859L20.3313 43.7136ZM19.2834 42.6657L45.1112 16.838C37.9413 10.2179 26.7594 10.3891 19.797 17.3515C12.8345 24.3139 12.6634 35.4958 19.2834 42.6657Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filterRestricted_d",
    x: 0.421077,
    y: 0.153501,
    width: 64.6003,
    height: 64.6003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.17786
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.17786
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestricted);
export default __webpack_public_path__ + "static/media/restricted.78539ec7c3a40549fdf3fc6d50b78ed1.svg";
export { ForwardRef as ReactComponent };